import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UploadContractData } from "../types/uploadContract";

export const editContract = (payload: UploadContractData) => {
   return apiClient<ApiResponse>("/v1/contrato", {
      method: "PUT",
      body: payload
   })
}
